import type {
	AbschnittCCandidateGender,
	AbschnittCElectionListVoteResult,
	CandidateId
} from "@/lib/abschnittc/AbschnittCElection";
import type { EvaluatorContext } from "@/lib/abschnittc/impl/EvaluatorContext";

export interface AbschnittCElectionListVoteResultReaderOptions {
	vote: AbschnittCElectionListVoteResult;
	candidates: CandidateId[];
	gender: AbschnittCCandidateGender;
	context: EvaluatorContext;
}

export class AbschnittCElectionListVoteResultApprovalReader {

	constructor(private options: AbschnittCElectionListVoteResultReaderOptions) {
	}

	genderFilteredVotes() {
		return Object.entries(this.options.vote.votes).filter(value => {
			return value[1].list === this.options.gender;
		}).map(value => value[1]);
	}

	isApproved(candidateId: CandidateId) {
		const votes = this.genderFilteredVotes();

		let yesVotes = 0;
		let noVotes = 0;

		for (const vote of votes) {
			if (vote.rankings[candidateId] > 0) {
				yesVotes++;
			} else if (vote.rankings[candidateId] === 0) {
				noVotes++;
			} else {
				// abstention or invalid vote
			}
		}

		const isApproved = yesVotes > noVotes;

		this.options.context.message("approval", candidateId, [yesVotes, noVotes], isApproved);
		this.options.context.message("text", `Bewerber*in ${this.options.context.candidateName(candidateId)} erhielt auf ${noVotes} Stimmzetteln die Punktzahl 0 und auf ${yesVotes} Stimmzetteln eine höhere Punktzahl.`);

		return isApproved;
	}

	approvedCandidates() {
		const out: CandidateId[] = [];
		for (const id of this.options.candidates) {
			if (this.isApproved(id)) {
				out.push(id);
				this.options.context.message("text", `Bewerber*in ${this.options.context.candidateName(id)} ist zugelassen.`);
			} else {
				this.options.context.message("text", `Bewerber*in ${this.options.context.candidateName(id)} ist nicht zugelassen.`);
			}
		}

		return out;
	}
}
